// Client-side mirrors of server validation rules. Source of truth lives in
// apps/api/src/routes/buckets.ts — if the server tightens or relaxes a rule,
// update here too. The server is still authoritative; these helpers exist for
// pre-submit UX so users don't round-trip a 422 for obvious mistakes.

export const BUCKET_NAME_HINT =
  'Lowercase letters, digits, and hyphens. Must start and end with a letter or digit. 3–63 characters.';

const BUCKET_NAME_RE = /^[a-z0-9][a-z0-9-]*[a-z0-9]$/;

export function validateBucketName(name: string): string | null {
  if (name.length < 3) return 'Bucket name must be at least 3 characters';
  if (name.length > 63) return 'Bucket name must be at most 63 characters';
  if (!BUCKET_NAME_RE.test(name)) {
    return 'Use only lowercase letters, digits, and hyphens. Cannot start or end with a hyphen.';
  }
  return null;
}
